import type { GetLogsArgs, LogsPage } from '../types/logs';
import { apiUrl, parseJsonOrThrow } from './http';

/** GET — one page of request logs (`page` 1-based, `limit` up to 500). */
export const getLogs = async ({
  page,
  limit,
}: GetLogsArgs = {}): Promise<LogsPage> => {
  const params = new URLSearchParams();
  if (page != null) params.set('page', String(page));
  if (limit != null) params.set('limit', String(limit));
  const query = params.toString();
  const res = await fetch(apiUrl(`/php/logs.php${query ? `?${query}` : ''}`), {
    headers: { Accept: 'application/json' },
  });
  // A failed SQL query still answers 200 with `{ error, query, details }`.
  const body = await parseJsonOrThrow<Partial<LogsPage> & { error?: string }>(
    res
  );
  if (body.error) throw new Error(body.error);
  return {
    page: Number(body.page ?? page ?? 1),
    limit: Number(body.limit ?? limit ?? 50),
    total_records: Number(body.total_records ?? 0),
    total_pages: Number(body.total_pages ?? 0),
    data: Array.isArray(body.data) ? body.data : [],
  };
};
